import Request from '@/api/request';

export const getProfile = async () => {
  let params = {}
  return await Request.get('/v1/users/me/profile', params).then((res) => {
    return res;
  });
};


export const getUserProfile = async (id) => {
  let params = {};
  return await Request.get('/v1/users/' + id, params).then((res) => {
    return res;
  });
}

export const putProfile = async (profileData) => {
  return await Request.put('/v1/users/me/profile', profileData).then((res) => {
    return res;
  });
};

export const postAvatar = async (fileAvatar) => {
  let uri = '/v1/users/me/avatar';
  return await Request.fileformpost(uri,'fileavatar', fileAvatar).then((res) => {
    return res;
  });
}

export const getMeManuscripts = async (start, limit) => {
  let params = {};
  const requestParams = {
    ...params,
    sort: {
      'id' : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/users/me/manuscripts', requestParams).then((res) => {
    return res;
  });
}

export const putMeManuscript = async (id, params) => {
  return await Request.put('/v1/users/me/manuscripts/' + id, params).then((res) => {
    return res;
  });
}

export const postMeManuscriptFile = async (id, file, params) => {
  return await Request.fileformpost('/v1/users/me/manuscripts/' + id + '/files', 'file', file, params).then((res) => {
    return res;
  });
}

export const getMeManuscriptFile = async (id, params) => {
  return await Request.get('/v1/users/me/manuscripts/' + id + '/files', params).then((res) => {
    return res;
  });
}

export const offlineMeManuscriptFile = async (id, fileid) => {
  return await Request.delete('/v1/users/me/manuscripts/' + id + '/files/' + fileid).then((res) => {
    return res;
  });
}

export const confirmMeManuscript = async (id) => {
  return await Request.put('/v1/users/me/manuscripts/' + id + '/confirm').then((res) => {
    return res;
  });
}

export const getManuscript = async (id) => {
  let params = {};
  return await Request.get('/v1/manuscripts/' + id, params).then((res) => {
    return res;
  });
}

export const getMeOrders = async (params) => {
  const requestParams = {
    ...params,
    sort: {
      'id' : -1,
    },
    pagination: {
      'start' : 0,
      'limit' : 100,
    }
  };
  return await Request.get('/v1/users/me/orders', requestParams).then((res) => {
      return res;
  });
}